<template>

    <div v-show="show" class="page-header">

    	<h1>
            <lang :labelKey="pageTitle"></lang>
            <template v-if="pageTitle2 != ''">: {{ pageTitle2 }}</template>
        </h1>

        <slot name="afterHeading"></slot>

        <template v-if="showBack === true && $route.meta.isParent != true">

            <!--
            <div @click="goBack()" class="goBack">
                <span class="icon is-small"><i class="fa fa-angle-left"></i></span>
                zurück
            </div>
            -->
            <!--
            <router-link class="goBack" v-if="$routerHistory.hasPrevious()" :to="{ path: $routerHistory.previous().path }">
                <span class="icon is-small"><i class="fa fa-angle-left"></i></span> zurück
            </router-link>
            -->

            <!--
            <router-link v-if="$routerHistory.hasPrevious()" :to="{ path: $routerHistory.previous().path }" custom v-slot="{ navigate }">
                <a @click="navigate" class="goBack" @keypress.enter="navigate" role="link"><span class="icon is-small"><i class="fa fa-angle-left"></i></span> zurück</a>
            </router-link>
            -->

            <div @click="goBack()" class="goBack">
                <!-- <span class="icon is-small"><i class="fa fa-angle-left"></i></span> -->
                zurück
            </div>

        </template>

	</div>

</template>


<script>

export default {

    name: 'pageHeader',

    props: {
        show: {
            type: Boolean,
            default: true
        },
        backRoute: {
            type: String,
            default: null,
        },
        showBack: {
            type: Boolean,
            default: true
        },
        pageTitle: {
            type: String,
            default: ''
        },
        pageTitle2: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: true
        }
    },


    data () {

        return {

        }

    },

    computed: {

        previousRoute() {

            return this.$store.getters.getPreviousRoute;

        }

    },

    mounted() {


    },

    methods: {

        goBack() {

          // console.log("go back ...");
          this.$router.back();
          // this.$router.go(-1);

          // console.log("previousRoute: ", this.previousRoute);
          // this.$router.push(this.previousRoute.fullPath);

          /*
          if(this.backRoute != null) {
              this.$router.push({ name: this.backRoute});
          } else {

              this.$router.go(-1);
              // this.$router.back();
          }
          */
        }
    }

}

</script>

<style lang="scss" scoped>
    .goBack {
        display: inline-block;
        margin: 2px 0 0 0;
        font-size: 11px;
        color: #aaa;
        text-transform: uppercase;
        line-height: 11px;
        cursor: pointer;
        transition: color .3s ease;
        &:hover {
            color: #000;
        }
        span.icon {
            vertical-align: baseline;
            display: none;
        }
    }

</style>
